import { render, staticRenderFns } from "./DesempenhoNotaAluno.vue?vue&type=template&id=1a0acafc&scoped=true"
import script from "./DesempenhoNotaAluno.vue?vue&type=script&lang=js"
export * from "./DesempenhoNotaAluno.vue?vue&type=script&lang=js"
import style0 from "./DesempenhoNotaAluno.vue?vue&type=style&index=0&id=1a0acafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0acafc",
  null
  
)

export default component.exports